import { Button } from "@/components/ui/button";
import { Edit, Key, Trash2 } from "lucide-react";

export const AdminUsersTab = ({ users, openEditUserModal, handleSendResetPassword, handleDeleteUser }) => {
  return (
    <div className="space-y-6">
      <p className="text-slate-500">{users.filter(u => !u.is_deleted).length} users</p>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full">
          <thead className="bg-slate-50">
            <tr>
              <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">User</th>
              <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Role</th>
              <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Status</th>
              <th className="text-left px-6 py-4 text-xs font-semibold text-slate-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200">
            {users.filter(u => !u.is_deleted).map((u, idx) => (
              <tr key={u.user_id} data-testid={`user-row-${idx}`}>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center">
                      {u.picture ? (
                        <img src={u.picture} alt="" className="w-10 h-10 rounded-full" />
                      ) : (
                        <span className="font-semibold text-slate-600">{u.name?.charAt(0)?.toUpperCase()}</span>
                      )}
                    </div>
                    <div>
                      <p className="font-medium text-slate-900">{u.name}</p>
                      <p className="text-sm text-slate-500">{u.email}</p>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className={`text-xs px-2 py-1 rounded-full ${
                    u.role === "admin" ? "bg-purple-100 text-purple-700" :
                    u.role === "merchant" ? "bg-indigo-100 text-indigo-700" :
                    "bg-slate-100 text-slate-700"
                  }`}>{u.role}</span>
                </td>
                <td className="px-6 py-4">
                  <span className={`text-xs px-2 py-1 rounded-full ${
                    u.is_approved !== false ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"
                  }`}>{u.is_approved !== false ? "Active" : "Pending"}</span>
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-2">
                    <Button size="sm" variant="ghost" onClick={() => openEditUserModal(u)} className="h-8" data-testid={`edit-user-${idx}`}><Edit className="h-4 w-4" /></Button>
                    <Button size="sm" variant="ghost" onClick={() => handleSendResetPassword(u.user_id, u.email)} className="h-8 text-indigo-600 hover:bg-indigo-50" title="Send Reset Password Email" data-testid={`reset-password-${idx}`}><Key className="h-4 w-4" /></Button>
                    <Button size="sm" variant="ghost" onClick={() => handleDeleteUser(u.user_id)} className="h-8 text-red-600 hover:bg-red-50" disabled={u.role === "admin"} data-testid={`delete-user-${idx}`}><Trash2 className="h-4 w-4" /></Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
